import React from 'react';

const LeftSection = ({ setSelectedOption, closeProfileModelHandler }) => {

    const QuestsAndTournamentHandler = () => {
        closeProfileModelHandler();
        setSelectedOption('option3')
    }

    return (
        <div className='h-full flex gap-[10px] p-[32px] flex-col justify-between items-center' >
            <div className='flex flex-col items-start gap-[16px]'>
                <p className='text-[#FAFAFA] text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px] opacity-50'>Your FrodoBot Points:</p>
                <div className='flex items-center gap-[8px]'>
                    <p className='text-[#FFF] text-[42px] not-italic font-semibold leading-[42px] tracking-[-2.52px]'>0 FBP</p>
                </div>
                <p className='text-[#FAFAFA] text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>FrodoBot Points (FBP) allow you to drive Earth Rovers, purchase TC, and use it as currency for transactions within the network.</p>
                <p className='text-[#FAFAFA] text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>Want to earn more FBP? You can win some at quests and tournaments, as well as hosting your own Earth Rover. Click below to start!</p>
            </div>
            <div className='flex flex-col items-start gap-[16px] self-stretch'>
                <button className='flex w-full h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[32px] bg-[#25BD66]' onClick={QuestsAndTournamentHandler}>
                    <p className='text-[#FAFAFA] text-[20px] not-italic font-semibold leading-[20px] tracking-[-0.8px]'>
                        Quests & Tournaments!
                    </p>
                </button>
                <button className='flex w-full h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[32px] bg-[#000]' onClick={() => { window.open(`https://shop.frodobots.com/`) }}>
                    <p className='text-[#FAFAFA] text-[20px] not-italic font-semibold leading-[20px] tracking-[-0.8px]'>
                        Get an Earth Rover!
                    </p>
                </button>
            </div>
        </div>
    )
}

export default LeftSection